export enum PatientTreatmentTabKey {
	PROFILE = 'profile',
	HEALTH_PLANS = 'healthPlans',
}
